export default __webpack_public_path__ + "static/media/slider-4.e4b4b7c0.jpg";